//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions, mapState } from "vuex";
import numericclean from "@/components/numericClean";

export default {
  components: {
    numericclean
  },
  data() {
    return {
      loadComplete: true,
      selected: [],
      pagination: {
        rowsPerPage: 30,
        page: 1,
        sortBy: "orderNumber"
      },
      orders: [],
      selectedSupplier: null,
      supplierExchangeRate: null,
      searchQuery: "",
      totalText: "",
      totalValue: "",
      totalValueNative: "",
      currencyDate: null,
      fromDate: null,
      toDate: null,
      columns: [
        {
          name: "orderNumber",
          align: "left",
          label: this.$t("purchaseConsolidation.orderNumber"),
          field: "orderNumber",
          sortable: true
        },
        {
          name: "supplierName",
          align: "left",
          label: this.$t("purchaseConsolidation.supplierName"),
          field: "supplierName",
          sortable: true
        },
        {
          name: "orderDate",
          align: "left",
          label: this.$t("purchaseConsolidation.orderDate"),
          field: "orderDate",
          format: val => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true
        },
        {
          name: "deliveryDate",
          align: "left",
          label: this.$t("purchaseConsolidation.deliveryDate"),
          field: "deliveryDate",
          format: val => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true
        },
        {
          name: "supplierOrderNumber",
          align: "left",
          label: this.$t("purchaseConsolidation.supplierOrderNumber"),
          field: "supplierOrderNumber",
          sortable: true
        },
        {
          name: "label",
          align: "left",
          label: this.$t("purchaseConsolidation.label"),
          field: "label",
          sortable: true
        },
        {
          name: "purchaseOrderStatusId",
          align: "left",
          label: this.$t("purchaseConsolidation.orderStatus"),
          field: "purchaseOrderStatusId",
          format: val => this.$t("purchaseConsolidation.status-" + val),
          sortable: true
        },
        {
          name: "totalPrice",
          align: "right",
          label: this.$t("purchaseConsolidation.totalPrice"),
          field: "totalPrice",
          sortable: true
        }
      ],
      transactionPagination: {
        rowsPerPage: 30,
        page: 1,
        sortBy: "orderNumber"
      },
      transactionColumns: [
        {
          name: "id",
          align: "left",
          label: "",
          field: "id",
          style: "width: 0px",
          sortable: true
        },
        {
          name: "productNumber",
          align: "left",
          label: this.$t("order.productNumber"),
          field: "productNumber",
          style: "width: 200px",
          sortable: true
        },
        {
          name: "productName",
          align: "left",
          label: this.$t("order.productName"),
          field: "productName",
          sortable: true
        },
        {
          name: "productType",
          align: "left",
          label: this.$t("order.productType"),
          field: "productType",
          sortable: true
        },
        {
          name: "locationName",
          align: "left",
          label: this.$t("order.locationName"),
          field: "locationName",
          sortable: true
        },
        {
          name: "quantity",
          align: "right",
          label: this.$t("order.quantity"),
          field: "numberOfItems",
          style: "width: 100px",
          sortable: true
        },
        {
          name: "discountPercentage",
          align: "right",
          label: this.$t("purchaseConsolidation.discountPercentage"),
          field: "discountPercentage",
          style: "width: 100px",
          sortable: true
        },
        {
          name: "price",
          align: "right",
          label: this.$t("purchaseConsolidation.price"),
          field: "price",
          style: "width: 100px",
          sortable: true
        }
      ]
    };
  },

  computed: {
    ...mapState("main", ["suppliers", "currencies"]),

    filteredSuppliers() {
      const searchQuery = this.searchQuery.toLowerCase();
      return this.suppliers.filter(supplier =>
        supplier.name.toLowerCase().includes(searchQuery)
      );
    }
  },

  watch: {
    selected: {
      handler(newSelected) {
        if (this._unwatchSelectedTransactionsForSelected) {
          this._unwatchSelectedTransactionsForSelected.forEach(unwatch =>
            unwatch()
          );
        }

        this._unwatchSelectedTransactionsForSelected = newSelected.map(order =>
          this.$watch(
            () => order.selectedTransactions,
            () => {
              this.updateSummary();
            },
            { deep: true }
          )
        );

        this.updateSummary();
      },
      deep: true
    }
  },

  mounted() {
    this.currencyDate = date.formatDate(Date.now(), "DD-MM-YYYY");
  },

  methods: {
    async refresh() {
      if (!this.selectedSupplier) {
        return;
      }

      if (this._unwatchSelectedTransactionsForOrder) {
        this._unwatchSelectedTransactionsForOrder.forEach(unwatch => unwatch());
      } else {
        this._unwatchSelectedTransactionsForOrder = [];
      }

      this.orders = [];
      this.selected = [];
      this.loadComplete = false;

      const notif = this.$q.notify({
        message: this.$t("purchaseConsolidation.loading"),
        timeout: 0,
        spinner: true
      });

      const currency = this.currencies.find(
        x => x.id === (this.selectedSupplier.currencyCodeID ?? 1)
      );

      this.supplierExchangeRate = await this.getExchangeRate(currency.id);

      this.totalText =
        this.$t("purchaseConsolidation.total") + " (" + currency.code + ")";

      const payload = {
        supplierId: this.selectedSupplier.id
      };

      if (this.fromDate != null && this.fromDate !== "") {
        payload.fromDate = date.formatDate(
          date.extractDate(this.fromDate, "DD-MM-YYYY"),
          "YYYY-MM-DDTHH:mm:ss.sssZ"
        );
      }

      if (this.toDate != null && this.toDate !== "") {
        payload.toDate = date.formatDate(
          date.extractDate(this.toDate, "DD-MM-YYYY"),
          "YYYY-MM-DDTHH:mm:ss.sssZ"
        );
      }

      this.orders = await this.getNonCreditedPurchaseOrdersBySupplier(payload);
      this.orders.forEach(order => {
        this.initOrder(order);
        const unwatch = this.$watch(
          () => order.selectedTransactions,
          () => {
            this.setTotalPriceForOrder(order);
          },
          { deep: true }
        );
        this._unwatchSelectedTransactionsForOrder.push(unwatch);
      });

      this.updateSummary();

      notif();

      this.loadComplete = true;
    },

    async onSupplierSelected(supplier) {
      this.selectedSupplier = supplier;
      await this.refresh();
    },

    filterSuppliers(val, update) {
      update(() => {
        this.searchQuery = val;
      });
    },

    formatPrice(price, currency) {
      return `${price.toFixed(2)} ${currency ? currency.code : ""}`;
    },

    formatLongPrice(price, currency) {
      return `${
        currency
          ? this.$t("purchaseConsolidation.total") +
            " (" +
            currency.code +
            "): "
          : ""
      }${price.toFixed(2)}`;
    },

    async initOrder(order) {
      this.setTransactionsForOrder(order);
      this.setTotalPriceForOrder(order);
      this.setCurrencyForOrder(order);
    },

    setTransactionsForOrder(order) {
      const transactions = order.orderItems
        .map(item =>
          item.transactions.map(transaction => {
            const processedTransaction = { ...transaction };
            if (processedTransaction.discountPercentage > 0) {
              const discount = (processedTransaction.discountPercentage * processedTransaction.price) / 100;
              processedTransaction.price = processedTransaction.price - discount;
            }
            return processedTransaction;
          })
        )
        .flat();
      this.$set(order, "transactions", transactions);
      this.$set(order, "selectedTransactions", [...transactions]);
    },

    setTotalPriceForOrder(order) {
      const totalPrice = order.selectedTransactions.reduce(
        (sum, transaction) => {
          const qtySum = transaction.numberOfItems * transaction.price;
          const discount = (qtySum * transaction.discountPercentage) / 100;
          return sum + (qtySum - discount);
        },
        0
      );
      this.$set(order, "totalPrice", totalPrice);
    },

    setCurrencyForOrder(order) {
      const currency = this.currencies.find(x => x.id === order.currencyCodeId);
      this.$set(order, "currency", currency);
    },

    async updateSummary() {
      let totValue = 0;
      let totValueNative = 0;

      this.selected.forEach(order => {
        if (order.selectedTransactions.length) {
          order.selectedTransactions.forEach(transaction => {
            const qtySum = transaction.numberOfItems * transaction.price;
            const discount = (qtySum * transaction.discountPercentage) / 100;
            totValue += qtySum - discount;

            const exchangeRate = this.supplierExchangeRate?.exchangeRate;
            if (exchangeRate) {
              totValueNative += (qtySum - discount) * exchangeRate;
            } else {
              totValueNative += qtySum - discount;
            }
          });
        }
      });

      this.totalValue = new Intl.NumberFormat("no-NO", {
        minimumFractionDigits: 2
      }).format(totValue);

      this.totalValueNative = new Intl.NumberFormat("no-NO", {
        minimumFractionDigits: 2
      }).format(Math.round(totValueNative * 100) / 100);
    },

    async saveAdjustment() {
      if (!this.selected.length) {
        this.$q.notify({
          type: "negative",
          message: this.$t("purchaseConsolidation.noTransactionsSelected")
        });
        return;
      }

      const transactions = this.selected
        .flatMap(order => order.selectedTransactions)
        .filter(transaction => transaction.numberOfItems > 0);

      if (!transactions.length) {
        this.$q.notify({
          type: "negative",
          message: this.$t("purchaseConsolidation.noTransactionsSelected")
        });
        return;
      }

      const currencyDateParts = this.currencyDate.split("-");
      if (currencyDateParts.length !== 3) {
        this.$q.notify({
          type: "negative",
          message: this.$t("purchaseConsolidation.noCurrencyDateSelected")
        });
        return;
      }

      const notif = this.$q.notify({
        message: this.$t("purchaseConsolidation.adjustingTransactions") + "...",
        timeout: 0,
        spinner: true
      });

      const dto = {
        transactions,
        currencyDate: `${currencyDateParts[2]}-${currencyDateParts[1]}-${currencyDateParts[0]}`
      };

      try {
        await this.adjustTransactions(dto);
        this.$q.notify({
          type: "positive",
          message: this.$t("purchaseConsolidation.transactionsAdjusted")
        });
        this.refresh();
      } catch (error) {
        this.$q.notify({
          type: "negative",
          message: this.$t("purchaseConsolidation.adjustmentFailed")
        });
      } finally {
        notif();
      }
    },

    saveAdjustmentDisabled() {
      return this.selected.every(order => !order.selectedTransactions.length);
    },

    async currencyDateChanged() {
      this.currencyDate = this.autoCompleteDate(this.currencyDate);
    },

    async fromDateChanged() {
      this.fromDate = this.autoCompleteDate(this.fromDate);
      await this.refresh();
    },

    async toDateChanged() {
      this.toDate = this.autoCompleteDate(this.toDate);
      await this.refresh();
    },

    autoCompleteDate(strDate) {
      if (strDate.length > 0 && strDate.length < 7) {
        if (isNaN(parseInt(strDate))) return "";
        try {
          if (strDate.length < 6) {
            let today = new Date();
            if (strDate.length == 1)
              strDate = "0" + strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 2)
              strDate = strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 3) {
              strDate = strDate.substring(0, 2) + "0" + strDate.substring(2, 3);
              strDate = strDate + date.formatDate(today, "YY");
            } else if (strDate.length == 4)
              strDate = strDate + date.formatDate(today, "YY");
            else if (strDate.length == 5) {
              strDate = strDate.substring(0, 4);
              strDate = strDate + date.formatDate(today, "YY");
            }
          }

          let newDate = date.extractDate(strDate, "DDMMYY");
          return date.formatDate(newDate, "DD-MM-YYYY");
        } catch (error) {
          return "";
        }
      }
      return strDate;
    },

    ...mapActions("main", [
      "getNonCreditedPurchaseOrdersBySupplier",
      "getExchangeRate",
      "adjustTransactions"
    ])
  }
};
